<template>
    <div>
        <img src="../../../assets/i5gam/images/cmsInfoPopup.png" usemap="#Map2">
        <map name="Map2">
            <area shape="rect" coords="242,466,458,523" href="javascript:;" alt="공지사항 바로가기" @click="btn_noticeClick">
            <!--<area shape="rect" coords="180,582,530,665" href="javascript:;" alt="동영상 바로가기" @click="btn_youtubeClick">-->
        </map>
        <!-- <img src="../../../assets/i5gam/images/serverTestInfo.jpg" usemap="#Map1">
        <map name="Map1">
            <area shape="rect" coords="258,396,455,447" href="javascript:;" alt="3월 출석부 수정기한 안내" @click="btn_noticeClick()">
        </map> -->
    </div>
</template>

<script>
export default {
    name : 'startSetupInfoPopup',
    props: ['index'],
    methods : {
        btn_youtubeClick : function(){
            this.$store.commit('closePopup');
            window.open('https://youtu.be/f6GtVBSvzXw');
        },
        btn_noticeClick : function(){
            //상세페이지로 이동하기 위해 공지사항 sn 넣어줘야함
            this.$router.push({ name: 'views.i5gam.cs.cs', params : {sn : 375}});
            //this.$router.push({ name: 'views.i5gam.cs.cs'});

            this.$store.commit('closePopup', this.index);
            this.$store.commit('closePopup');
        },
        btn_myPageClick : function(){
            if(!this.loginAt){
                this.$toasted.show('로그인해주세요.');
                this.$store.commit('closePopup');
                return false;
            }

            this.$router.push({ name: 'views.i5gam.member.myPage'});
            this.$store.commit('closePopup');
        }
        /*
        btn_cloudClick : function(){
            this.$router.push({ name: 'views.i5gam.cs.cloud'});
            this.$store.commit('closePopup', this.index);
            this.$store.commit('closePopup');
        }
        */
    },
    computed : {
        mberInfo : function(){
            return this.$store.getters.getMberInfo;
        },
        loginAt : function(){
            return this.$store.getters.getLoginAt;
        }
    },
}
</script>